'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$3() {
  this.bfO = null;
  this.bfM = null;
  this.bfN = false;
  this.bfK = null;
  this.bfL = false;
  this.bfP = false;
  this.bfQ = false;
  this.bfO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$3 as $c_Lpresto_PrestoRouter$$anon$3 };
$p = $c_Lpresto_PrestoRouter$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$3;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$3() {
}
export { $h_Lpresto_PrestoRouter$$anon$3 as $h_Lpresto_PrestoRouter$$anon$3 };
$h_Lpresto_PrestoRouter$$anon$3.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bfO;
});
$p.t = (function() {
  if ((!this.bfN)) {
    this.bfM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfN = true;
  }
  return this.bfM;
});
$p.ad = (function() {
  if ((!this.bfL)) {
    this.bfK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfL = true;
  }
  return this.bfK;
});
$p.v = (function() {
  if ((!this.bfQ)) {
    this.bfP = false;
    this.bfQ = true;
  }
  return this.bfP;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$3, "presto.PrestoRouter$$anon$3", ({
  O4: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$3 as $d_Lpresto_PrestoRouter$$anon$3 };
//# sourceMappingURL=presto.-Presto-Router$$anon$3.js.map
